import React, { useState } from "react";

export default function PromesasJesus() {
    const [fontSizes, setFontSizes] = useState(16);

  const aumentar = () => {
    if (fontSizes < 22) {
      const newSize = fontSizes + 2;
      setFontSizes(newSize);
    }
  };
  const restar = () => {
    if (fontSizes > 12) {
      const newSize = fontSizes - 2;
      setFontSizes(newSize);
    }
  };
  return (
    <>
      <div className="container devocionario pb-5 mb-5">
        <div className={"font-" + fontSizes}>
          <h6>PROMESA DE JESÚS</h6>
          <i>Mensaje de Jesús dado en Salta el 13 de Junio de 1995</i>
          <p>
            El mundo nunca se preguntó, cuantas lágrimas derramé por vosotros
            durante mi Pasión y cuantas y amargas lágrimas derramó mi Santa
            Madre, para ayudar a la Redención, Yo les pido que honren cada
            lágrima que por vosotros derramé en esas horas amargas, prometo al
            que las honre rezando todos los días de su vida cinco Padrenuestros,
            cinco Avemarías y cinco Gloria.
          </p>
          <ol>
            <li>
              <p>
                Asistirle junto a mi Santísima Madre, en la batalla final de su
                vida.
              </p>
            </li>
            <li>
              <p> La conversión total de su alma.</p>
            </li>
            <li>
              <p>Una verdadera contrición de sus pecados.</p>
            </li>
            <li>
              <p>
                En el día del juicio, perdonarlo para que entre Conmigo en la
                Gloria.
              </p>
            </li>
          </ol>
        </div>
      </div>
      <div className="btn-fonts d-flex">
        <button onClick={aumentar}>
          <strong>A</strong>
        </button>
        <button onClick={restar} style={{ fontSize: "1.1rem" }}>
          <strong>A</strong>
        </button>
      </div>
    </>
  );
}
